module.exports = __webpack_public_path__ + "rookie_icon.ec26f5005e20c8116cc3.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/img/usc-store/awards/rookie_icon.jpg
// module id = ../../../../../src/assets/img/usc-store/awards/rookie_icon.jpg
// module chunks = main